/**
 * Closes the header inline search dropdown when clicking / tapping outside the search UI.
 * Relies on :focus-within CSS on [data-header-inline-search] — this ensures activeElement blurs.
 */
function blurSearchIfOutside(event) {
  const root = document.querySelector('[data-header-inline-search]');
  if (!root || root.contains(event.target)) return;

  const active = document.activeElement;
  if (active && root.contains(active) && typeof active.blur === 'function') {
    active.blur();
  }
}

document.addEventListener('pointerdown', blurSearchIfOutside, true);
